var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertRuleUpdated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.1281 3.21296L2.34105 21.034C2.11889 21.4145 2.00124 21.8469 2.00001 22.2875C1.99878 22.7281 2.11402 23.1612 2.33405 23.543C2.5564 23.9265 2.87482 24.2455 3.25796 24.4686C3.6411 24.6916 4.07574 24.811 4.51905 24.815H26.0921C26.5345 24.8101 26.9681 24.6903 27.3503 24.4673C27.7325 24.2443 28.0501 23.9258 28.2721 23.543C28.4931 23.1618 28.6096 22.7291 28.6096 22.2885C28.6096 21.8479 28.4931 21.4151 28.2721 21.034L17.4831 3.21296C17.2534 2.84207 16.9329 2.53597 16.5518 2.3237C16.1707 2.11142 15.7418 2 15.3056 2C14.8693 2 14.4404 2.11142 14.0593 2.3237C13.6782 2.53597 13.3577 2.84207 13.1281 3.21296Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.83301V15.688",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19.5,
    r: 1,
    fill: "currentColor",
    stroke: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 11.83301V15.688",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19.5,
    r: 1,
    fill: "currentColor",
    stroke: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRuleUpdated);
export default __webpack_public_path__ + "static/media/alert_rule_updated.91ab4d4b8868381f234fa287af993389.svg";
export { ForwardRef as ReactComponent };